












import {Component, Vue} from 'vue-property-decorator';
import TPLogo from './assets/logo.svg';
import ArrowLeftIcon from './assets/arrow-left.svg';

@Component({
	components: {
		TPLogo: TPLogo,
		ArrowLeftIcon: ArrowLeftIcon
	},
	computed: {}
})
export default class App extends Vue {


}
